import { render } from "./Navbar.vue?vue&type=template&id=32edc486&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=32edc486&scoped=true&lang=css"
import "./Navbar.vue?vue&type=style&index=1&id=32edc486&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32edc486"]])

export default __exports__